import { render, staticRenderFns } from "./About.vue?vue&type=template&id=b7bdccec&scoped=true&lang=html&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&id=b7bdccec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bdccec",
  null
  
)

component.options.__file = "About.vue"
export default component.exports